interface Props {
  message: string | null | undefined;
}

export function FormError({ message }: Props): JSX.Element | null {
  if (!message) return null;
  return (
    <div className="field-error" role="alert" data-testid="form-error">
      {message}
    </div>
  );
}
